// extracted by mini-css-extract-plugin
module.exports = {"spaceWrapper":"AffiliateStreamsTable_spaceWrapper__3xlAE","search":"AffiliateStreamsTable_search__3PLfN"};